<template>
  <a
    :id="id"
    ref="part"
    :class="channelClass"
    class="block cursor-pointer"
    :style="{'height': channelHeight, '--angle' : rotateAngle }"
  >
    <div v-if="plainView" class="flex items-end pb-1" :class="toRightFlow ? 'justify-end' : 'justify-start'" :style="{'height': channelHeight }">
      <div v-if="part.outlet_size && part.part_type== 'channel'" class="w-3 h-3 bg-black rounded-full" :class="toRightFlow ? 'mr-0.5' : 'ml-0.5'">&nbsp;</div>
      <div v-else-if="bottomOutlet && isLastChannel" class="w-3 h-3 bg-black rounded-full" :class="toRightFlow ? 'mr-0.5' : 'ml-0.5'">&nbsp;</div>
    </div>
    <div v-else-if="part.outlet_size && part.part_type== 'accessory'" class="flex items-end pb-2" :class="toRightFlow ? 'justify-end' : 'justify-start'" :style="{'height': channelHeight }">
      <div class="w-full" style="max-width:16px; max-height:16px;" :class="toRightFlow ? 'mr-0.5' : 'ml-0.5'">
        <div class="bg-black rounded-full" style="height:0; width: 100%; padding-bottom: 100%;">&nbsp;</div>
      </div>
    </div>
  </a>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
  props: {
    isLastChannel: Boolean,
    toRightFlow  : Boolean,
    plainView    : Boolean,
    index        : Number,
    angle        : String,
    part         : Object,
    selected     : Object,
    bottomOutlet : {
      type   : [ Object, Boolean],
      default: false,
    },
  },
  data () {
    return {
      isMounted : false,
    }
  },
  computed: {
    id () {
      return `part-${uuid()}`
    },
    channelHeight() {
      let { width, depth } = this.part
      if (this.plainView) {
        return width + 'rem'
      }

      if (depth == 0) {
        depth = 1
      }

      let i = (this.index + 1) / 10
      return  (depth + i).toFixed(2) + 'rem'
    },
    channelClass (){
      let classes = [
        this.part.neutral || this.part.type == 'cb' || this.plainView ? 'part' : 'depth',
        this.toRightFlow ? 'to-right' : 'to-left',
        this.selected.id == this.part.id ? 'selected' : '',
        this.part.availables ? 'allowed' : '',
      ]

      return classes.join(' ')
    },
    rotateAngle () {
      return this.angle + 'deg'
    },
  },
  mounted() {
    this.isMounted = true
  },
}
</script>
<style>
:root {
    --bg: #E0E0E0;
    --border: #BDBDBD;
    --allow: #9c9c9c;
    --allow-border: #8f8e8e;
    --hover-bg: #002B56;
    --selected: rgba(0, 63, 125);
    --angle: 0deg
}

.part {
    background   : var(--bg);
    border       : .5px solid var(--border);
    border-top   : 1px solid var(--border);
    border-bottom: 1px solid var(--border);
    color        : var(--bg);
    padding-right: 2px;
    text-align   : right;
}

.part.allowed {
    background: var(--allow);
    border    : 1px solid var(--allow-border);
    color     : var(--allow);
}

.part.allowed:hover {
  color : var(--bg);
  border: 1px solid var(--hover-bg) !important;
}

.part.selected,
.selected {
    border: 0;
    background: var(--selected) !important;
}

/* .depth {
    overflow  : hidden;
    position  : relative;
    text-align: right;
} */
.depth {
    overflow  : hidden;
    position  : relative;
    text-align: right;
}

.depth::before {
  content      : '';
  background   : var(--bg);
  position     : absolute;
  border       : .5px solid var(--border);
  border-top   : 1px solid var(--border);
  border-bottom: 0;
  top          : 0;
  left         : 0;
  width        : 100%;
  height       : 100%;
}


/* .depth::after {
  content: '';
  position: absolute;
  top: 99%;
  width: 115%;
  height: 35%;
  background: white;
  border-top: 1px solid var(--border);
} */
.depth::after {
  content: '';
  position: absolute;
  top: 97%;
  width: 115%;
  height: 35%;
  background: white;
  border-top: 1px solid var(--border);
}

.depth.to-right::after {right: 0; transform-origin: bottom right; transform: rotate(var(--angle));}
.depth.to-left::after {left: 0; transform-origin: bottom left; transform: rotate(var(--angle));}

.depth.allowed::before {
    background   : var(--allow) !important;
    border       : .5px solid var(--allow-border);
    border-top   : 1px solid var(--allow-border);
    border-bottom: 0;
}

.depth.allowed::after {
   border-top   : 1px solid var(--allow-border);
}

.depth.allowed:hover::before {
    background: var(--hover-bg) !important;
}

.depth.selected::before {
    background: var(--selected) !important;
}

</style>
